module.exports = __webpack_public_path__ + "img/modular-coding.37616ce9.svg";